module.exports = __webpack_public_path__ + "img/img2c.c01d25a9.png";